import { Card } from "flowbite-react";
import { FiRefreshCw } from "react-icons/fi";

const getErrorMessage = (status) => {
  switch (status) {
    case 402:
      return {
        title: "Créditos insuficientes",
        message:
          "Você não tem créditos suficientes para consultar o veículo. 💸 " +
          "Adicione créditos para continuar a pesquisa por placa, chassi ou RENAVAM.",
      };
    case 403:
      return {
        title: "Acesso negado",
        message:
          "Você atingiu seu limite mensal ou não possui permissão para consultas veiculares. 🔐 " +
          "Fale com o administrador para liberar o acesso ou ampliar o limite.",
      };
    case 404:
      return {
        title: "Veículo não encontrado",
        message:
          "Não localizamos registros para os dados informados. 🔍 " +
          "Confira a placa (com UF correta), o chassi (17 caracteres) ou o RENAVAM e tente novamente.",
      };
    case 422:
      return {
        title: "Dados inválidos",
        message:
          "O formato informado é inválido. 🧾 " +
          "Verifique: placa no padrão ABC1D23, chassi com 17 caracteres e RENAVAM numérico.",
      };
    case 500:
      return {
        title: "Ops! Instabilidade na consulta",
        message:
          "Não conseguimos concluir a consulta veicular agora. 😕 " +
          "Pode ser uma instabilidade do provedor ou restrição temporária de dados " +
          "(ex.: Detran fora do Ar).",
      };
    default:
      return {
        title: "Ops! Algo deu errado",
        message:
          "Não foi possível concluir a consulta veicular. 😕 " +
          "Pode ser uma instabilidade momentânea ou uma restrição do provedor.",
      };
  }
};

const ErrorQueryVehicle = ({ status }) => {
  const { title, message } = getErrorMessage(status);

  return (
    <Card className="flex items-center justify-center p-4">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="bg-yellow-100 p-4 rounded-full">
          <FiRefreshCw className="w-5 h-5 md:w-10 md:h-10 text-yellow-500" />
        </div>
        <h2 className="text-lg md:text-2xl font-bold text-gray-800">{title}</h2>
        <p className="text-gray-600 text-sm md:text-base">
          {message}
          <br />
          <b className="block mt-4">
            Que tal tentar novamente em instantes? 🔄
          </b>
        </p>
      </div>
    </Card>
  );
};

export default ErrorQueryVehicle;
